import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLockRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 8v3.2h8V8a4 4 0 1 0-8 0m-2.4 3.2V8a6.4 6.4 0 1 1 12.8 0v3.2c1.8 0 3.2 1.4 3.2 3.2v11.2c0 1.8-1.4 3.2-3.2 3.2H9.6a3 3 0 0 1-3.2-3.2V14.4c0-1.8 1.4-3.2 3.2-3.2M20 13.6H9.6q-.7.1-.8.8v11.2q.1.7.8.8h12.8q.7-.1.8-.8V14.4q-.1-.7-.8-.8z" })
});
export default SvgLockRegularIcon;
